import { Box, FlexLayout, H4, Icon } from '@deity-io/portal-ui';
import ValidationReport from 'components/Endpoints/RequestExplorer/Tabs/ValidationReport';
import { IconButton } from 'components/IconButton/IconButton';
import { JSONEditor } from 'components/JSONEditor';
import { UIContext } from 'contexts/UIContext';
import type { ISchema } from 'contracts/interfaces';
import { useContext, useState } from 'react';
import type { FC } from 'react';
import { useValidateToSchemaMutation } from 'services/graphql/generated/hooks';

type MappingReportProps = {
  report: {
    items: number;
    errors: number;
    duration?: number;
    results: Array<{
      mapping: { key: string; path: string };
      mapper: { key: string | number; path: string };
      value?: any;
      error?: string | null;
    }>;
  };
  targetModel: ISchema;
};
export const MappingReport: FC<MappingReportProps> = ({ report, targetModel }) => {
  const ctxUI = useContext(UIContext);
  const [validationCache, setValidationCache] = useState<Record<string, any>>({});
  const [validateToSchemaMutation, { data: schemaValidationResult, loading: validatingSchema }] =
    useValidateToSchemaMutation();

  const validateOutput = (resultIndex: number, data: Record<string, any>) => {
    // eslint-disable-next-line no-console
    console.log({
      data: JSON.stringify(data),
      schema: JSON.stringify(targetModel),
      env: ctxUI?.state.currentEnvironment?.name
    });

    validateToSchemaMutation({
      variables: {
        data: JSON.stringify(data),
        schema: JSON.stringify(targetModel),
        env: ctxUI?.state.currentEnvironment?.name
      }
    })
      .catch(er => {
        // eslint-disable-next-line no-console
        console.log('Mutation Failed', er);
      })
      .then(value => {
        const newCache = { ...validationCache };
        if (value && value.data) {
          newCache[`index${resultIndex}`] = value.data?.validateToSchema;
        } else {
          delete newCache[`index${resultIndex}`];
        }
        setValidationCache(newCache);

        return value;
      });
  };

  return (
    <Box>
      <Box>Items : {report.items}</Box>
      <Box>Failures : {report.errors}</Box>
      <FlexLayout flexDirection="column" width="full">
        {report.results.map((result, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={`index${index}`}>
            {result.error ? (
              <Box sx={{ padding: '5px', backgroundColor: '#f8f8f8' }}>
                <FlexLayout alignItems="center" width="full" size="small">
                  <H4 fontWeight="bold" size="small" style={{ textTransform: 'capitalize' }}>
                    {result.mapping.path}
                  </H4>
                  <Box style={{ marginLeft: 'auto', marginRight: '0px' }}>
                    <Icon key="validate" icon="checkCircle" color="error" />
                  </Box>
                </FlexLayout>
                <Box>{result.error}</Box>
              </Box>
            ) : (
              <JSONEditor
                locked
                value={result.value}
                label={result.mapping.path}
                toolIcons={[
                  <IconButton
                    key="validate"
                    tooltip="Validate output"
                    icon="checkCircle"
                    onClick={() => {
                      validateOutput(index, result.value);
                    }}
                  />
                ]}
              />
            )}
            {validationCache[`index${index}`] && <ValidationReport report={validationCache[`index${index}`]} />}
          </Box>
        ))}
      </FlexLayout>
    </Box>
  );
};
